module.exports = __webpack_public_path__ + "img/35-None of these.c1083758.png";